module.exports = __webpack_public_path__ + "static/media/c1.68d0fa55.svg";